import { sendEvent } from "@swiggy-private/portal-dineout-context";
import { OBJECT_POSITION, SCREEN_NAME } from "./constants";
import { AnalyticsContextParams, CreateEventParams } from "./types";

export const buildAnalyticsContext = ({
    billPaymentData,
    clickedCTA,
    tableContext,
}: AnalyticsContextParams): string => {
    const { tableId = "", restaurantId = "" } = tableContext;
    let ctas;
    if (clickedCTA) {
        ctas = clickedCTA;
    } else if (Array.isArray(billPaymentData?.ctas)) {
        ctas = billPaymentData?.ctas;
    } else {
        ctas = [];
    }
    return JSON.stringify({
        title: billPaymentData?.title,
        description: billPaymentData?.description,
        ctas,
        table_id: tableId,
        restaurant_id: restaurantId,
    });
};

const createAnalyticsEvent = ({
    eventFn,
    objectName,
    billPaymentData,
    clickedCTA,
    tableContext,
}: CreateEventParams) => {
    return {
        eventFn,
        screenName: SCREEN_NAME,
        objectName,
        context: buildAnalyticsContext({ billPaymentData, clickedCTA, tableContext }),
        objectValue: "",
        objectPosition: OBJECT_POSITION,
    };
};

export const sendImpressionEvent = ({
    eventFn,
    objectName,
    billPaymentData,
    tableContext,
}: CreateEventParams): void => {
    sendEvent(createAnalyticsEvent({ eventFn, objectName, billPaymentData, tableContext }));
};

export const sendClickEvent = ({
    eventFn,
    objectName,
    billPaymentData,
    clickedCTA: clickedCTA,
    tableContext,
}: CreateEventParams): void => {
    sendEvent(createAnalyticsEvent({ eventFn, objectName, billPaymentData, clickedCTA, tableContext }));
};
